import omit from 'lodash/omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const removeRule = (ruleId: string) => (model: Model) => {
  const existingRule = model.modelData.rulesById[ruleId];

  if (existingRule) {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'rulesById',
      omit(model.modelData.rulesById, ruleId)
    );
  }
};
